import { VALID_PL_BILL_DETAILS_TYPES } from "@swiggy-private/cart-ui";
import { PLBillButtonPrimitive, PLBillImagePrimitive, PLBillTextPrimitive } from "@swiggy-private/cart-types";

export const isTextualPrimitive = (
    primitive: PLBillTextPrimitive | PLBillButtonPrimitive | PLBillImagePrimitive,
): primitive is PLBillTextPrimitive | PLBillButtonPrimitive => primitive.type !== VALID_PL_BILL_DETAILS_TYPES.IMAGE;
